import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaSearch } from "react-icons/fa";
import "./BuscarMatricula.css";

// Busca sem diferenciar acentos e maiúsculas/minúsculas.
const normalizarBusca = (valor) =>
  String(valor ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

function BuscarMatricula({ onSelecionar, valorInicial = "", disabled = false }) {
  const [termo, setTermo] = useState(valorInicial || "");
  const [resultados, setResultados] = useState([]);
  const [mostrando, setMostrando] = useState(false);
  const [selecionado, setSelecionado] = useState(null);

  useEffect(() => {
    if (termo.trim().length < 2) {
      setResultados([]);
      return;
    }

    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const fetchData = async () => {
      try {
        // 1️⃣ Buscar imóveis
        const resImoveis = await axios.get("/api/imoveis", { headers });
        const lista = Array.isArray(resImoveis.data) ? resImoveis.data : [];

        // 2️⃣ Buscar locatários (para trazer nome do usuário/locatário)
        const resLocatarios = await axios.get("/api/locatarios", { headers });
        const listaLoc = Array.isArray(resLocatarios.data) ? resLocatarios.data : [];

        // 3️⃣ Indexar locatários pela matriculaId
        const mapaLocatarios = {};
        listaLoc.forEach((l) => {
          if (l.matriculaId) mapaLocatarios[l.matriculaId] = l.nomeLocatario;
        });

        // 4️⃣ Filtrar imóveis por QUALQUER informação da matrícula (código, apelido,
        // nº da matrícula, endereço, bairro, cidade, proprietário, cartório, locatário...).
        // Vírgula/ponto e vírgula separam termos que precisam aparecer todos.
        const termos = normalizarBusca(termo)
          .split(/[,;]+/)
          .map((t) => t.trim())
          .filter((t) => t.length > 0);

        const filtrados = lista.filter((item) => {
          const texto = normalizarBusca(
            [...Object.values(item), mapaLocatarios[item.id]].filter((v) => v !== null && v !== undefined && typeof v !== "object").join(" "),
          );
          return termos.every((t) => texto.includes(t));
        });

        // 5️⃣ Enriquecer os resultados com nome do locatário
        const enriquecidos = filtrados.map((it) => ({
          ...it,
          nomeLocatario: mapaLocatarios[it.id] || "", // id do imóvel = matriculaId no locatário
        }));

        setResultados(enriquecidos);
      } catch (err) {
        console.error("Erro ao buscar matrículas:", err);
      }
    };

    const timeout = setTimeout(fetchData, 300);
    return () => clearTimeout(timeout);
  }, [termo]);

  const handleSelecionar = (item) => {
    setSelecionado(item);
    setTermo(`${item.codigoMatricula} - ${item.apelido}`);
    setMostrando(false);

    // Agora enviamos os dados corretos:
    onSelecionar({
      id: item.id,
      codigoMatricula: item.codigoMatricula,
      apelido: item.apelido,

      // ENVIANDO NOME DO PROPRIETÁRIO DA MATRÍCULA
      nomeProprietario: item.nomeProprietarioMatricula ?? "",

      // ENVIANDO NOME DO LOCATÁRIO (se existir)
      nomeLocatario: item.nomeLocatario ?? "",
    });
  };

  return (
    <div className="busca-matricula">
      <div className="busca-input">
        <input
          type="text"
          placeholder="Buscar Matrícula (qualquer informação)"
          value={termo}
          onChange={(e) => {
            setTermo(e.target.value);
            setSelecionado(null);
          }}
          disabled={disabled}
          onFocus={() => setMostrando(true)}
          onBlur={() => setTimeout(() => setMostrando(false), 200)}
        />
        <FaSearch className="icone-lupa" />
      </div>

      {mostrando && resultados.length > 0 && (
        <ul className="lista-resultados">
          {resultados.map((r) => (
            <li key={r.id} onMouseDown={(e) => e.preventDefault()} onClick={() => handleSelecionar(r)}>
              <strong>{r.codigoMatricula}</strong> – {r.apelido}
              {r.cidade ? ` (${r.cidade}${r.uf ? `/${r.uf}` : ""})` : ""}
              {(r.endereco || r.nomeProprietarioMatricula) && (
                <div style={{ fontSize: "0.78em", opacity: 0.75 }}>
                  {[r.endereco && `${r.endereco}${r.numero ? `, ${r.numero}` : ""}`, r.bairro, r.nomeProprietarioMatricula].filter(Boolean).join(" · ")}
                </div>
              )}
            </li>
          ))}
        </ul>
      )}

      {mostrando && resultados.length === 0 && termo.length >= 2 && <div className="lista-resultados vazio">Nenhuma matrícula encontrada.</div>}

      {selecionado && (
        <div className="matricula-selecionada">
          Matrícula selecionada:&nbsp;
          <strong>{selecionado.codigoMatricula}</strong> — {selecionado.apelido}
        </div>
      )}
    </div>
  );
}

export default BuscarMatricula;
